<template>
  <div>
    <!-- {{ configuracionSelected }} -->
    <v-select
      v-model="cancha.asignacion"
      :options="listCanchasBD"
      placeholder="Seleccione Cancha"
      :clearable="false"
    />
  </div>
</template>
<script>
import { ref, watch } from '@vue/composition-api'
import vSelect from 'vue-select'

export default {
  components: {
    vSelect,
  },
  props: {
    listCanchasBD: Array,
    cancha: Object,
  },
  setup(props) {
    const configuracionSelected = ref(null)
    watch(configuracionSelected, val => {
      props.cancha.asignacion = val // 🔥 aquí se asigna al objeto padre
    })
    return {
      configuracionSelected,
    }
  },
}
</script>
